import React from "react";

const HeroComponent = () => {
  return (
    <div
      className="relative w-full h-[350px] md:h-[450px] bg-cover bg-center flex items-center justify-center flex-col text-center"
      style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1599643477877-530eb83abc8e?auto=format&fit=crop&q=80&w=1600')",
      }}
    >
      {/* Dark gradient overlay matching the Hirapanna design */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/60 to-black/80"></div>
      
      {/* Subtle bottom glow effect pointing towards the yellow bar */}
      <div className="absolute bottom-0 left-0 w-full h-24 bg-gradient-to-t from-[#B08D5B]/30 to-transparent mix-blend-overlay"></div>

      <div className="relative z-10 px-4">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-white mb-4 md:mb-6 tracking-wide drop-shadow-lg">
          Our Collections
        </h1>
        <p className="text-gray-300 text-sm md:text-base font-light tracking-wider max-w-2xl mx-auto drop-shadow-md">
          Explore our curated selection of fine jewelry, crafted with precision and passion
        </p>
      </div>
    </div>
  );
};

export default HeroComponent;
